type SourceRowWithLocation = {
  productId: number;
  lot: string | null;
  inventoryLocationId: number;
  unitOfMeasureId?: number;
};

export const createGroupKey = (productId: number, lot: string | null, unitOfMeasureId?: number): string => {
  const base = lot ? `${productId}::${lot}` : `${productId}::no-lot`;
  return unitOfMeasureId && unitOfMeasureId !== 0 ? `${base}::${unitOfMeasureId}` : base;
};

export const populateLocationIdsAcrossGroups = <T extends SourceRowWithLocation>(sourceRows: T[]): T[] => {
  const groupMap = new Map<string, number[]>();

  sourceRows.forEach((row, index) => {
    const key = createGroupKey(row.productId, row.lot, row.unitOfMeasureId);
    const existing = groupMap.get(key);
    if (existing) {
      existing.push(index);
    } else {
      groupMap.set(key, [index]);
    }
  });

  const result = [...sourceRows];

  groupMap.forEach((indices) => {
    const firstNonZeroLocationId = indices.map((i) => result[i].inventoryLocationId).find((locationId) => locationId && locationId !== 0);

    if (firstNonZeroLocationId) {
      for (const index of indices) {
        result[index] = { ...result[index], inventoryLocationId: firstNonZeroLocationId };
      }
    }
  });

  return result;
};
